/* tslint:disable */
/* eslint-disable */
/**
 * Property Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.0.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ContactPhone
 */
export interface ContactPhone {
    /**
     * 
     * @type {string}
     * @memberof ContactPhone
     */
    phone?: string;
}

export function ContactPhoneFromJSON(json: any): ContactPhone {
    return ContactPhoneFromJSONTyped(json, false);
}

export function ContactPhoneFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContactPhone {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'phone': !exists(json, 'phone') ? undefined : json['phone'],
    };
}

export function ContactPhoneToJSON(value?: ContactPhone | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'phone': value.phone,
    };
}


